import { render, staticRenderFns } from "./IhtiyatiHacizAlacakKalemiForm.vue?vue&type=template&id=2db71da6"
import script from "./IhtiyatiHacizAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./IhtiyatiHacizAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports